import { useContext, useEffect } from "react";
import { OwcIcon, OwcList, OwcListItem } from "@one/react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AdminLinkItem from "../features/booking-admin/AdminLinkItem";
import { BookingContext } from "../features/booking/context";
import GroupListItem from "../features/booking-groups/GroupListItem";
import { TogglerContext } from "../contexts";

const DrawerMenu = ({ setTabUrl, popupEnableStatus, setSideMenu, sideMenu }) => {
  const history = useHistory();
  const { isEditMode, dispatchAction: bookingDispatchAction } = useContext(BookingContext);
  const { setIsMini, isMini, isPinned, setLeaveStatus } = useContext(TogglerContext);

  const handleRedirect = (item) => {
    if (!item.isActive) {
      if (popupEnableStatus) {
        setTabUrl(item.url);
        setLeaveStatus(true);
      } else {
        if (isEditMode) {
          bookingDispatchAction({
            type: "resetBookingData",
          });
        }
        history.replace(item.url);
      }
    }
  };

  useEffect(() => {
    const pathName = window.location.pathname;
    const updatedSideMenu = sideMenu.map((item) => {
      item.isActive = item.url === pathName;
      return item;
    });
    setSideMenu(updatedSideMenu);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    history.listen((location) => {
      const pathName = location.pathname;
      const updatedSideMenu = sideMenu.map((item) => {
        item.isActive = item.url === pathName;
        return item;
      });
      setSideMenu(updatedSideMenu);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  const handleItemClick = (item) => {
    if (!isMini && !isPinned) setIsMini(true)
    if (item.text !== 'Group views') {
      handleRedirect(item)
    }
  }

  return (
    <>
      <OwcList data-testid="sidebar-list" id={"side-bar-menu-parent"} key={"side-bar-menu-parent"}>
        {sideMenu.map((item, i) => {
          switch (item.text) {
            case "Group views":
              return <GroupListItem
                onClick={() => handleItemClick(item)}
                item={item}
                handleRedirect={handleRedirect}
                id={`side-menu-${i}`}
                key={`side-menu-${i}`}
                disabled={item.disable}
                isMini={isMini}
              />;
            case "Admin panel":
              return <AdminLinkItem
                onClick={() => handleItemClick(item)}
                item={item}
                handleRedirect={handleRedirect}
                id={`side-menu-${i}`}
                key={`side-menu-${i}`}
                disabled={item.disable}
              />;
            default:
              return <OwcListItem
                selected={item.isActive}
                onClick={() => handleItemClick(item)}
                noBorder
                id={`side-menu-${i}`}
                key={`side-menu-${i}`}
                disabled={item.disable}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  {typeof item.icon === "string" ? <OwcIcon name={item.icon} type="legacy" /> : <div>{item.icon}</div>}

                  <span style={{ marginLeft: 15 }}>{item.text}</span>
                </div>
              </OwcListItem>
          }
        })}
      </OwcList>
    </>
  );
};

export default DrawerMenu;
